import is from "is_js";
import { useAppContext } from "Main";
import { lazy, Suspense, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { BrowserRouter as Router } from "react-router-dom";

const FalconRoutes = lazy(() => import("routes"));
const ToastContainerLazy = lazy(() => import("./ToastContainerWrapper"));

const App = () => {
  const {
    config: { navbarPosition },
  } = useAppContext();

  useEffect(() => {
    const html = document.documentElement;

    if (is.windows()) html.classList.add("windows");
    if (is.chrome()) html.classList.add("chrome");
    if (is.firefox()) html.classList.add("firefox");
    if (is.safari()) html.classList.add("safari");

    if (navbarPosition === "double-top") {
      html.classList.add("double-top-nav-layout");
    }

    return () => {
      html.classList.remove("double-top-nav-layout");
    };
  }, [navbarPosition]);

  return (
    <Suspense
      fallback={
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      }
    >
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <FalconRoutes />
        <ToastContainerLazy />
      </Router>
    </Suspense>
  );
};

export default App;
